<script setup lang="ts">
const { t } = useI18n()
const { supportPortal } = useLinks()
const isContactUsModalOpen = ref(false)
const isMenuOpen = ref(false)

const itemClass = `
  flex
  w-full
  items-center
  gap-2
  rounded-md
  px-2
  py-1.5
  text-left
  text-sm
  text-gray-700
  hover:bg-neutral-800/[0.08]
`
</script>

<template>
  <ContactUsModal
    v-if="isContactUsModalOpen"
    v-model="isContactUsModalOpen"
  />

  <UiPopover v-model:open="isMenuOpen">
    <UiPopoverTrigger as-child>
      <UiButton
        type="button"
        size="xs"
        variant="ghost"
        icon-leading="docue:life-buoy-01"
        class="relative"
        :class="{ 'bg-neutral-800/[0.08] hover:bg-neutral-800/[0.08]': isMenuOpen }"
      >
        {{ t('user-menu.link.support') }}
      </UiButton>
    </UiPopoverTrigger>

    <UiPopoverContent
      #default="{ close }"
      side="top"
      align="start"
      :side-offset="4"
      class="flex min-w-44 flex-col p-1"
    >
      <button
        type="button"
        :class="itemClass"
        @click="isContactUsModalOpen = true; close()"
      >
        <span class="flex size-4 items-center justify-center">
          <UiIcon
            name="docue:message-chat-circle"
            class="size-full"
          />
        </span>
        {{ t('contact-us') }}
      </button>
      <NuxtLink
        v-if="supportPortal"
        :href="supportPortal"
        :class="itemClass"
        target="_blank"
        external
        @click="close()"
      >
        <span class="flex size-4 items-center justify-center">
          <UiIcon
            name="docue:book-open-01"
            class="size-full"
          />
        </span>
        {{ t('user-menu.link.documentation') }}
      </NuxtLink>
    </UiPopoverContent>
  </UiPopover>
</template>
